export const UI = 'ui'
export const KE = 'ke'
export const FS = 'fs'
export const GEO = 'geo'
export const I18N = 'i18n'
